import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const propTypes = {
  object: PropTypes.object.isRequired,
};

function DisplayObject({ object }) {
  const capitalize = string => string[0].toUpperCase() + string.slice(1);

  return (
    object && (
      <Table>
        <TableBody>
          {Object.keys(object).map((key, i) => (
            <TableRow key={i} style={{ verticalAlign: 'top' }}>
              <TableCell
                style={{
                  fontWeight: 660,
                  padding: '10px',
                  border: `1px solid rgba(224, 224, 224, 1)`,
                }}
              >
                {capitalize(key)}
              </TableCell>
              <TableCell style={{ padding: '10px', border: `1px solid rgba(224, 224, 224, 1)` }}>
                {typeof object[key] === 'object' ? <DisplayObject object={object[key]} /> : object[key]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  );
}

const styles = theme => ({});

DisplayObject.propTypes = propTypes;
export default withStyles(styles)(withRouter(DisplayObject));
